(function () {
  'use strict';

  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;

  var wrappers = document.querySelectorAll('[data-predictive-search]');

  wrappers.forEach(function (wrapper) {
    var input = wrapper.querySelector('[data-predictive-search-input]');
    var resultsEl = wrapper.querySelector('[data-predictive-search-results]');
    var debounceTimer = null;
    var currentController = null;
    var lastQuery = '';

    if (!input || !resultsEl) return;

    input.addEventListener('input', function (e) {
      var query = e.target.value.trim();

      clearTimeout(debounceTimer);

      if (query.length < MIN_CHARS) {
        closeResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      if (resultsEl.innerHTML && input.value.trim().length >= MIN_CHARS) {
        openResults();
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        closeResults();
      }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeResults();
    });

    function fetchResults(query) {
      if (query === lastQuery) return;
      lastQuery = query;

      if (currentController) currentController.abort();
      currentController = new AbortController();

      resultsEl.classList.add('is-loading');

      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor';

      fetch(url, { signal: currentController.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('Predictive search request failed');
          return res.json();
        })
        .then(function (data) {
          renderResults(data.resources.results, query);
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') {
            resultsEl.innerHTML = '';
            closeResults();
          }
        })
        .finally(function () {
          resultsEl.classList.remove('is-loading');
        });
    }

    function renderResults(results, query) {
      var products = results.products || [];
      var collections = results.collections || [];
      var queries = results.queries || [];

      if (!products.length && !collections.length && !queries.length) {
        resultsEl.innerHTML =
          '<div class="predictive-search__empty">No results for "' + escapeHtml(query) + '"</div>';
        openResults();
        return;
      }

      var html = '';

      if (queries.length) {
        html += '<ul class="predictive-search__group predictive-search__suggestions">';
        queries.forEach(function (item) {
          html +=
            '<li><a href="' +
            item.url +
            '" class="predictive-search__suggestion">' +
            item.text +
            '</a></li>';
        });
        html += '</ul>';
      }

      if (products.length) {
        html += '<ul class="predictive-search__group predictive-search__products">';
        products.forEach(function (item) {
          var image = item.image
            ? '<img src="' + item.image + '" alt="" width="56" height="56" loading="lazy">'
            : '<div class="predictive-search__product-image--placeholder"></div>';

          html +=
            '<li>' +
            '<a href="' +
            item.url +
            '" class="predictive-search__product">' +
            '<span class="predictive-search__product-image">' +
            image +
            '</span>' +
            '<span class="predictive-search__product-info">' +
            '<span class="predictive-search__product-title">' +
            escapeHtml(item.title) +
            '</span>' +
            '<span class="predictive-search__product-price">' +
            item.price +
            '</span>' +
            '</span>' +
            '</a>' +
            '</li>';
        });
        html += '</ul>';
      }

      if (collections.length) {
        html += '<ul class="predictive-search__group predictive-search__collections">';
        collections.forEach(function (item) {
          html +=
            '<li><a href="' +
            item.url +
            '" class="predictive-search__collection">' +
            escapeHtml(item.title) +
            '</a></li>';
        });
        html += '</ul>';
      }

      html +=
        '<a href="/search?q=' +
        encodeURIComponent(query) +
        '" class="predictive-search__view-all">View all results for "' +
        escapeHtml(query) +
        '"</a>';

      resultsEl.innerHTML = html;
      openResults();
    }

    function openResults() {
      resultsEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function closeResults() {
      resultsEl.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  });
})();
